module.exports = __webpack_public_path__ + "static/media/msk.dc81dfea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/msk.jpg
// module id = 427
// module chunks = 0